
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/data-scientist/[slug]",
      function () {
        return require("private-next-pages/jobs/data-scientist/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/data-scientist/[slug]"])
      });
    }
  